import React from "react";

const features = [
  {
    icon: (
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1.48999"
          y="1.5"
          width="73"
          height="73"
          rx="36.5"
          stroke="#F4A84A"
          stroke-width="3"
        />
        <g clip-path="url(#clip0_3183_426)">
          <path
            d="M30.2996 20.5L20.49 30.3096L24.6257 34.4453L25.0359 34.001C25.9929 33.0667 26.4999 31.9217 26.5569 30.5659C26.6139 29.2101 26.2208 28.0195 25.3777 26.9941L26.9841 25.3877C27.3487 25.6839 27.7247 25.9175 28.1121 26.0884C28.4994 26.2593 28.8982 26.3789 29.3083 26.4473L29.5134 25.3877C29.1944 25.3193 28.8925 25.2225 28.6077 25.0972C28.3228 24.9718 28.0437 24.818 27.7703 24.6357L30.2996 22.0381L32.1111 23.8496L32.863 23.0977L30.2996 20.5ZM24.5574 32.8047L22.0281 30.3096L24.5574 27.7803C25.1498 28.5094 25.446 29.3468 25.446 30.2925C25.446 31.2381 25.1498 32.0755 24.5574 32.8047ZM39.0496 30.8223L39.9724 30.5146L40.28 31.4375L39.3572 31.7451L39.0496 30.8223ZM43.322 20.6367L30.1628 25.0459L33.1023 33.8643L34.1277 33.5225L33.0339 30.1729C34.1505 29.6488 34.9879 28.8285 35.5461 27.7119C36.1044 26.5954 36.2468 25.4333 35.9734 24.2256L38.1267 23.4395C38.5597 24.3737 39.2091 25.12 40.075 25.6782C40.9408 26.2365 41.8751 26.5156 42.8777 26.5156C43.06 26.5156 43.248 26.5042 43.4417 26.4814C43.6353 26.4587 43.8233 26.4245 44.0056 26.3789L46.4666 33.7959L47.5261 33.4541L43.322 20.6367ZM32.658 29.1133L31.5642 25.7637L34.9138 24.6357C35.0961 25.5472 34.9765 26.4245 34.5549 27.2676C34.1334 28.1107 33.5011 28.7259 32.658 29.1133ZM39.2546 23.166L42.6042 22.0381L43.7322 25.3877C42.8207 25.6156 41.9434 25.513 41.1003 25.0801C40.2572 24.6471 39.642 24.0091 39.2546 23.166ZM40.3826 32.2578C40.0636 32.3717 39.7502 32.5142 39.4426 32.6851C39.135 32.856 38.8559 33.0667 38.6052 33.3174L39.3914 34.0693C39.5736 33.9098 39.773 33.7617 39.9895 33.625C40.206 33.4883 40.4509 33.3857 40.7244 33.3174C41.3168 33.1123 41.8979 33.0781 42.4675 33.2148C43.0372 33.3516 43.4587 33.6136 43.7322 34.001L44.655 33.3857C44.2221 32.7933 43.6069 32.3888 42.8093 32.1724C42.0118 31.9559 41.2029 31.9844 40.3826 32.2578ZM42.4675 37.5898H43.5955V38.6836H42.4675V37.5898ZM33.7175 37.5898H34.8455V38.6836H33.7175V37.5898ZM31.5642 37.5898H32.658V38.6836H31.5642V37.5898ZM27.155 37.5898H28.2488V38.6836H27.155V37.5898ZM40.3142 37.5898H41.408V38.6836H40.3142V37.5898ZM29.3083 37.5898H30.4363V38.6836H29.3083V37.5898ZM38.1267 37.5898H39.2546V38.6836H38.1267V37.5898ZM49.0642 37.5898H50.158V38.6836H49.0642V37.5898ZM44.7234 37.5898H45.8171V38.6836H44.7234V37.5898ZM46.8767 37.5898H48.0046V38.6836H46.8767V37.5898ZM35.905 37.5898H36.9988V38.6836H35.905V37.5898ZM27.155 52.2188H28.2488V53.3467H27.155V52.2188ZM49.0642 52.2188H50.158V53.3467H49.0642V52.2188ZM46.8767 52.2188H48.0046V53.3467H46.8767V52.2188ZM44.7234 52.2188H45.8171V53.3467H44.7234V52.2188ZM40.3142 52.2188H41.408V53.3467H40.3142V52.2188ZM42.4675 52.2188H43.5955V53.3467H42.4675V52.2188ZM29.3083 52.2188H30.4363V53.3467H29.3083V52.2188ZM38.1267 52.2188H39.2546V53.3467H38.1267V52.2188ZM33.7175 52.2188H34.8455V53.3467H33.7175V52.2188ZM31.5642 52.2188H32.658V53.3467H31.5642V52.2188ZM35.905 52.2188H36.9988V53.3467H35.905V52.2188ZM51.8669 41.2129V35.334H24.4207V55.5H51.8669V50.0312H54.0203V41.2129H51.8669ZM50.739 54.3721H25.446V53.2441H26.0271V52.1504H25.446V38.6152H26.0271V37.5215H25.446V36.3936H50.739V41.1445H44.8601C43.6296 41.1445 42.5872 41.5718 41.7327 42.4263C40.8782 43.2808 40.4509 44.3232 40.4509 45.5537C40.4509 46.7842 40.8782 47.8267 41.7327 48.6812C42.5872 49.5356 43.6296 49.9629 44.8601 49.9629H50.739V54.3721ZM52.8923 48.9033H44.8601C43.9486 48.9033 43.1682 48.5843 42.5188 47.9463C41.8694 47.3083 41.5447 46.5335 41.5447 45.6221C41.5447 44.7106 41.8694 43.9359 42.5188 43.2979C43.1682 42.6598 43.9486 42.3408 44.8601 42.3408H52.8923V48.9033ZM50.9441 20.7051C49.6908 20.7051 48.6199 21.1494 47.7312 22.0381C46.8425 22.9268 46.3982 23.9977 46.3982 25.251C46.3982 26.527 46.8425 27.6037 47.7312 28.481C48.6199 29.3582 49.6908 29.7969 50.9441 29.7969C52.1973 29.7969 53.2683 29.3696 54.157 28.5151C55.0457 27.6606 55.49 26.5954 55.49 25.3193C55.49 24.0661 55.0457 22.9837 54.157 22.0723C53.2683 21.1608 52.1973 20.7051 50.9441 20.7051ZM50.9441 28.7715C49.9871 28.7715 49.1611 28.4297 48.4661 27.7461C47.7711 27.0625 47.4236 26.2308 47.4236 25.251C47.4236 24.3167 47.7654 23.5021 48.449 22.8071C49.1326 22.1121 49.9643 21.7646 50.9441 21.7646C51.8783 21.7646 52.693 22.1007 53.3879 22.7729C54.0829 23.4451 54.4304 24.2712 54.4304 25.251C54.4076 26.2308 54.0544 27.0625 53.3708 27.7461C52.6873 28.4297 51.8783 28.7715 50.9441 28.7715ZM52.4138 25.627C52.4138 25.5814 52.3967 25.5415 52.3625 25.5073C52.3284 25.4731 52.2999 25.4333 52.2771 25.3877C52.2315 25.3649 52.1917 25.3364 52.1575 25.3022C52.1233 25.2681 52.0948 25.251 52.072 25.251C52.0264 25.2282 51.9866 25.2111 51.9524 25.1997C51.9182 25.1883 51.8897 25.1598 51.8669 25.1143C51.8214 25.0915 51.7815 25.0744 51.7473 25.063C51.7131 25.0516 51.6733 25.0459 51.6277 25.0459C51.6049 25.0459 51.5707 25.0345 51.5251 25.0117C51.4796 24.9889 51.4226 24.9775 51.3542 24.9775L51.4226 24.0547C51.4682 24.0547 51.5024 24.0604 51.5251 24.0718C51.5479 24.0832 51.5593 24.1003 51.5593 24.123C51.6049 24.123 51.6334 24.1401 51.6448 24.1743C51.6562 24.2085 51.6733 24.2256 51.696 24.2256C51.7416 24.2256 51.7701 24.2256 51.7815 24.2256C51.7929 24.2256 51.8214 24.2484 51.8669 24.2939C51.8897 24.3167 51.9068 24.3224 51.9182 24.311C51.9296 24.2996 51.9353 24.2939 51.9353 24.2939C51.9581 24.2939 51.9752 24.2939 51.9866 24.2939C51.998 24.2939 52.0264 24.2939 52.072 24.2939C52.072 24.2939 52.0834 24.2826 52.1062 24.2598C52.129 24.237 52.1404 24.2256 52.1404 24.2256L52.3455 23.918C52.2999 23.8952 52.2486 23.861 52.1917 23.8154C52.1347 23.7699 52.072 23.7129 52.0037 23.6445C51.9581 23.5078 51.8897 23.4167 51.7986 23.3711C51.7074 23.3255 51.6277 23.3027 51.5593 23.3027L51.6277 22.8242H51.2859C51.2631 22.8242 51.2346 22.8242 51.2004 22.8242C51.1663 22.8242 51.1492 22.847 51.1492 22.8926C51.1036 22.9154 51.0808 22.9325 51.0808 22.9438C51.0808 22.9552 51.0808 22.9837 51.0808 23.0293V23.3027C50.9669 23.3027 50.87 23.3027 50.7903 23.3027C50.7105 23.3027 50.6251 23.3255 50.5339 23.3711C50.4656 23.4167 50.3915 23.4565 50.3118 23.4907C50.232 23.5249 50.158 23.5762 50.0896 23.6445C50.0668 23.6901 50.0269 23.7414 49.97 23.7983C49.913 23.8553 49.8845 23.918 49.8845 23.9863C49.8617 24.0547 49.8446 24.1287 49.8333 24.2085C49.8219 24.2882 49.8162 24.3623 49.8162 24.4307C49.8162 24.5218 49.8219 24.6073 49.8333 24.687C49.8446 24.7668 49.8617 24.8408 49.8845 24.9092C49.9301 24.9775 49.97 25.0345 50.0042 25.0801C50.0383 25.1257 50.0668 25.1598 50.0896 25.1826C50.1352 25.2282 50.1864 25.2681 50.2434 25.3022C50.3004 25.3364 50.3744 25.3649 50.4656 25.3877C50.5339 25.3877 50.5966 25.3991 50.6536 25.4219C50.7105 25.4447 50.7618 25.4561 50.8074 25.4561L50.739 26.4473C50.6934 26.4473 50.6536 26.4359 50.6194 26.4131C50.5852 26.3903 50.5567 26.3789 50.5339 26.3789C50.4884 26.3789 50.4485 26.3675 50.4143 26.3447C50.3801 26.3219 50.363 26.3105 50.363 26.3105C50.3403 26.3105 50.3232 26.2992 50.3118 26.2764C50.3004 26.2536 50.2719 26.2422 50.2263 26.2422C50.2035 26.2422 50.1864 26.2422 50.175 26.2422C50.1637 26.2422 50.1352 26.2422 50.0896 26.2422C50.0668 26.2422 50.0497 26.2422 50.0383 26.2422C50.0269 26.2422 49.9985 26.2422 49.9529 26.2422C49.9301 26.2422 49.913 26.2422 49.9016 26.2422C49.8902 26.2422 49.8845 26.265 49.8845 26.3105L49.6111 26.6523C49.6794 26.7207 49.7535 26.7777 49.8333 26.8232C49.913 26.8688 49.9985 26.903 50.0896 26.9258C50.2035 26.9714 50.3004 27.0112 50.3801 27.0454C50.4599 27.0796 50.5567 27.1195 50.6707 27.165L50.6023 27.7119H50.8757C50.8985 27.7119 50.927 27.7062 50.9612 27.6948C50.9954 27.6834 51.0125 27.6663 51.0125 27.6436C51.0352 27.598 51.0523 27.5695 51.0637 27.5581C51.0751 27.5467 51.0808 27.5296 51.0808 27.5068V27.165C51.1947 27.165 51.2916 27.1479 51.3713 27.1138C51.4511 27.0796 51.5365 27.0397 51.6277 26.9941C51.696 26.9714 51.7701 26.9372 51.8499 26.8916C51.9296 26.846 52.0037 26.7891 52.072 26.7207C52.1404 26.6523 52.1917 26.5954 52.2258 26.5498C52.26 26.5042 52.2999 26.4245 52.3455 26.3105C52.3682 26.2422 52.3853 26.1681 52.3967 26.0884C52.4081 26.0086 52.4138 25.9232 52.4138 25.832C52.4138 25.832 52.4138 25.8035 52.4138 25.7466C52.4138 25.6896 52.4138 25.6497 52.4138 25.627ZM50.8757 24.7041C50.8074 24.6585 50.7504 24.63 50.7048 24.6187C50.6593 24.6073 50.6251 24.5902 50.6023 24.5674C50.5567 24.5218 50.5339 24.4819 50.5339 24.4478C50.5339 24.4136 50.5339 24.3623 50.5339 24.2939C50.5339 24.2484 50.5339 24.2199 50.5339 24.2085C50.5339 24.1971 50.5339 24.1686 50.5339 24.123C50.5339 24.1003 50.5453 24.0832 50.5681 24.0718C50.5909 24.0604 50.6023 24.0319 50.6023 23.9863C50.6023 23.9635 50.6251 23.9578 50.6707 23.9692C50.7162 23.9806 50.7618 23.9863 50.8074 23.9863C50.8302 23.9863 50.8586 23.9749 50.8928 23.9521C50.927 23.9294 50.9669 23.918 51.0125 23.918L50.8757 24.7041ZM51.2175 26.5156L51.2859 25.627C51.3542 25.6497 51.4112 25.6668 51.4568 25.6782C51.5024 25.6896 51.5365 25.7181 51.5593 25.7637C51.6049 25.7865 51.6277 25.8149 51.6277 25.8491C51.6277 25.8833 51.6277 25.9232 51.6277 25.9688C51.6277 26.1283 51.5935 26.2536 51.5251 26.3447C51.4568 26.4359 51.3542 26.4928 51.2175 26.5156ZM44.7234 43.4004C44.1537 43.4004 43.6695 43.5998 43.2708 43.9985C42.872 44.3973 42.6726 44.8701 42.6726 45.417C42.6726 45.9867 42.872 46.4652 43.2708 46.8525C43.6695 47.2399 44.1537 47.4336 44.7234 47.4336C45.2703 47.4336 45.7431 47.2399 46.1418 46.8525C46.5406 46.4652 46.74 45.9867 46.74 45.417C46.74 44.8701 46.5406 44.3973 46.1418 43.9985C45.7431 43.5998 45.2703 43.4004 44.7234 43.4004ZM44.7234 46.3398C44.4727 46.3398 44.2563 46.2487 44.074 46.0664C43.8917 45.8841 43.8005 45.6676 43.8005 45.417C43.8005 45.1663 43.8917 44.9499 44.074 44.7676C44.2563 44.5853 44.4727 44.4941 44.7234 44.4941C44.9513 44.4941 45.1563 44.5853 45.3386 44.7676C45.5209 44.9499 45.6121 45.1663 45.6121 45.417C45.6121 45.6676 45.5209 45.8841 45.3386 46.0664C45.1563 46.2487 44.9513 46.3398 44.7234 46.3398Z"
            fill="#F4A84A"
          />
        </g>
        <defs>
          <clipPath id="clip0_3183_426">
            <rect
              width="35"
              height="35"
              fill="white"
              transform="matrix(1 0 0 -1 20.49 55.5)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Affordable Rates",
    description:
      "What you see is what you pay. Transparent pricing with no surprises.",
  },
  {
    icon: (
      <svg
        width="77"
        height="76"
        viewBox="0 0 77 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="2.46997"
          y="1.5"
          width="73"
          height="73"
          rx="36.5"
          stroke="#F4A84A"
          stroke-width="3"
        />
        <path
          d="M35.1355 45.7917C35.1355 47.4025 33.8297 48.7083 32.2189 48.7083C30.608 48.7083 29.3022 47.4025 29.3022 45.7917C29.3022 44.1808 30.608 42.875 32.2189 42.875C33.8297 42.875 35.1355 44.1808 35.1355 45.7917Z"
          stroke="#F4A84A"
          stroke-width="1.5"
        />
        <path
          d="M49.7188 45.7917C49.7188 47.4025 48.413 48.7083 46.8022 48.7083C45.1913 48.7083 43.8855 47.4025 43.8855 45.7917C43.8855 44.1808 45.1913 42.875 46.8022 42.875C48.413 42.875 49.7188 44.1808 49.7188 45.7917Z"
          stroke="#F4A84A"
          stroke-width="1.5"
        />
        <path
          d="M24.9272 35.5834H48.2605M24.9272 35.5834C24.9272 36.7209 24.8981 40.0167 24.9331 43.2542C24.9855 44.3042 25.1604 45.1792 29.3047 45.7917M24.9272 35.5834C25.242 33.0459 26.6118 30.0417 27.3112 28.9042M35.1356 35.5834V28.2917M43.8711 45.7917H35.1278M24.9505 28.2917H39.8491C39.8491 28.2917 40.6361 28.2917 41.3355 28.3617C42.6471 28.4842 43.7487 29.0792 44.8504 30.5667C46.0169 32.1417 46.9138 34.1367 48.1029 35.2042C50.0789 36.9782 53.8385 36.4292 54.0484 40.1917C54.1009 42.1167 54.1009 44.2167 54.0134 44.5667C53.8729 45.5974 53.0783 45.7656 52.0898 45.7917C51.232 45.8145 50.1979 45.7511 49.6942 45.7917"
          stroke="#F4A84A"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    ),
    title: "Wide Vehicle Selection",
    description:
      "From compact cars to family-sized SUVs, we’ve got the perfect ride for every need.",
  },
  {
    icon: (
      <svg
        width="77"
        height="76"
        viewBox="0 0 77 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="2.45001"
          y="1.5"
          width="73"
          height="73"
          rx="36.5"
          stroke="#F4A84A"
          stroke-width="3"
        />
        <path
          d="M45.7917 36.7566C45.7917 36.2524 45.7917 36.0004 45.8675 35.7758C46.088 35.1231 46.6693 34.8699 47.2516 34.6046C47.9063 34.3064 48.2335 34.1574 48.5579 34.1311C48.9261 34.1013 49.2949 34.1807 49.6096 34.3573C50.0268 34.5914 50.3178 35.0364 50.6157 35.3982C51.9915 37.0691 52.6792 37.9047 52.931 38.8261C53.1341 39.5695 53.1341 40.3471 52.931 41.0906C52.5639 42.4344 51.4041 43.561 50.5456 44.6037C50.1065 45.137 49.8868 45.4038 49.6096 45.5594C49.2949 45.736 48.9261 45.8153 48.5579 45.7855C48.2335 45.7593 47.9063 45.6103 47.2516 45.312C46.6693 45.0468 46.088 44.7936 45.8675 44.1408C45.7917 43.9163 45.7917 43.6643 45.7917 43.1601V36.7566Z"
          stroke="#F4A84A"
          stroke-width="2"
        />
        <path
          d="M31.2084 36.7567C31.2084 36.122 31.1905 35.5516 30.6774 35.1053C30.4908 34.943 30.2433 34.8303 29.7484 34.6049C29.0938 34.3067 28.7665 34.1576 28.4421 34.1314C27.4691 34.0527 26.9455 34.7168 26.3844 35.3984C25.0086 37.0694 24.3207 37.9049 24.069 38.8262C23.8659 39.5698 23.8659 40.3474 24.069 41.0909C24.4361 42.4347 25.596 43.5612 26.4545 44.604C26.9957 45.2613 27.5126 45.8609 28.4421 45.7858C28.7665 45.7596 29.0938 45.6104 29.7484 45.3123C30.2433 45.0869 30.4908 44.9741 30.6774 44.8118C31.1905 44.3656 31.2084 43.7952 31.2084 43.1604V36.7567Z"
          stroke="#F4A84A"
          stroke-width="2"
        />
        <path
          d="M28.2917 34.125C28.2917 29.2925 32.8621 25.375 38.5 25.375C44.1379 25.375 48.7084 29.2925 48.7084 34.125"
          stroke="#F4A84A"
          stroke-width="2"
          stroke-linecap="square"
          stroke-linejoin="round"
        />
        <path
          d="M48.7083 45.7917V46.9584C48.7083 49.5357 46.0966 51.6251 42.875 51.6251H39.9583"
          stroke="#F4A84A"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    title: "24/7 Customer Support",
    description: "We’re here for you—anytime, anywhere.",
  },
  {
    icon: (
      <svg
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1.48999"
          y="1.5"
          width="73"
          height="73"
          rx="36.5"
          stroke="#F4A84A"
          stroke-width="3"
        />
        <path
          d="M43.3333 23.9167V29.7501M31.6667 23.9167V29.7501"
          stroke="#F4A84A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M38.9583 26.8333H36.0417C30.5419 26.8333 27.7921 26.8333 26.0835 28.5418C24.375 30.2503 24.375 33.0002 24.375 38.4999V41.4166C24.375 46.9163 24.375 49.6662 26.0835 51.3747C27.7921 53.0833 30.5419 53.0833 36.0417 53.0833H38.9583C44.458 53.0833 47.208 53.0833 48.9164 51.3747C50.625 49.6662 50.625 46.9163 50.625 41.4166V38.4999C50.625 33.0002 50.625 30.2503 48.9164 28.5418C47.208 26.8333 44.458 26.8333 38.9583 26.8333Z"
          stroke="#F4A84A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24.375 35.5833H50.625"
          stroke="#F4A84A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M33.125 45.0625C33.125 45.0625 35.3125 45.7917 36.0417 47.9792C36.0417 47.9792 39.2157 42.1458 43.3333 40.6875"
          stroke="#F4A84A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    title: "Easy Online Booking",
    description:
      "Reserve your car in seconds with our user-friendly booking system.",
  },
  {
    icon: (
      <svg
        width="77"
        height="76"
        viewBox="0 0 77 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="2.46997"
          y="1.5"
          width="73"
          height="73"
          rx="36.5"
          stroke="#F4A84A"
          stroke-width="3"
        />
        <path
          d="M34.125 39.9583C34.125 39.9583 35.5833 39.9583 37.0417 42.875C37.0417 42.875 41.6741 35.5833 45.7917 34.125"
          stroke="#F4A84A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M51.625 37.3091V33.0755C51.625 30.6838 51.625 29.488 51.0357 28.7078C50.4464 27.9276 49.1139 27.5488 46.4489 26.7913C44.6282 26.2737 43.0232 25.6502 41.7409 25.0809C39.9925 24.3048 39.1183 23.9167 38.5 23.9167C37.8817 23.9167 37.0075 24.3048 35.2592 25.0809C33.9768 25.6502 32.3719 26.2737 30.5511 26.7913C27.8861 27.5488 26.5537 27.9276 25.9643 28.7078C25.375 29.488 25.375 30.6838 25.375 33.0755V37.3091C25.375 45.5125 32.7582 50.4344 36.4496 52.3825C37.3349 52.8498 37.7775 53.0834 38.5 53.0834C39.2225 53.0834 39.6651 52.8498 40.5504 52.3825C44.2418 50.4344 51.625 45.5125 51.625 37.3091Z"
          stroke="#F4A84A"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    ),
    title: "Fully Insured Rentals",
    description: "Drive with confidence knowing you're covered.",
  },
  {
    icon: (
      <svg
        width="77"
        height="76"
        viewBox="0 0 77 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="2.45001"
          y="1.5"
          width="73"
          height="73"
          rx="36.5"
          stroke="#F4A84A"
          stroke-width="3"
        />
        <path
          d="M51.8696 31.2083C53.4879 34.9185 53.4879 39.1646 51.8696 42.8749M25.1304 42.8749C23.5121 39.1646 23.5121 34.9185 25.1304 31.2083"
          stroke="#F4A84A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M42.875 37.0417C42.875 39.4581 40.9163 41.4167 38.5 41.4167C36.0837 41.4167 34.125 39.4581 34.125 37.0417C34.125 34.6255 36.0837 32.6667 38.5 32.6667C40.9163 32.6667 42.875 34.6255 42.875 37.0417Z"
          stroke="#F4A84A"
          stroke-width="1.5"
        />
        <path
          d="M38.5 26.1042C44.4191 26.1042 49.4375 31.1035 49.4375 37.1685C49.4375 43.3301 44.3374 47.654 39.6266 50.5943C39.2833 50.7919 38.8951 50.8959 38.5 50.8959C38.1049 50.8959 37.7167 50.7919 37.3734 50.5943C32.6714 47.6253 27.5625 43.3514 27.5625 37.1685C27.5625 31.1035 32.5809 26.1042 38.5 26.1042Z"
          stroke="#F4A84A"
          stroke-width="1.5"
        />
      </svg>
    ),
    title: "Easy Pick-up & Drop-off",
    description:
      "Enjoy convenient location options or doorstep delivery (where available).",
  },
];

const WhyChooseUS = () => {
  return (
    <>
      <p className="text-4xl font-semibold text-center">
        Why Choose LA Exotic Autos
      </p>

      <div className="py-12 bg-[#F5F5F7]">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white shadow-md rounded-lg p-6 flex items-center text-center gap-4"
              >
                <div className="text-blue-500 text-4xl mb-4 col-span-1">
                  {feature.icon}
                </div>
                <div className="col-span-2 text-left">
                  <h3 className="text-lg font-semibold mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default WhyChooseUS;
